var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Fuse from 'fuse.js';
let restAPIdomain = window.location.origin;
const buildPage = (hotel, siteData) => {
    let hotelTypeHeader;
    let hotelTypeFooter;
    let content;
    let body;
    content = document.getElementById("content");
    body = document.body;
    hotelTypeHeader = hotel.hoteltype + "-" + "header";
    hotelTypeFooter = hotel.hoteltype + "-" + "footer";
    let dynamicHeaders;
    let dynamicFooters;
    dynamicHeaders = Array.from(document.getElementsByClassName("dynamic-header"));
    dynamicFooters = Array.from(document.getElementsByClassName("dynamic-footer"));
    let activeHeader;
    let activeFooter;
    activeHeader = document.getElementById(hotelTypeHeader);
    activeFooter = document.getElementById(hotelTypeFooter);
    let attibuteID;
    console.log(hotelTypeHeader);
    dynamicHeaders.map((item, index) => {
        attibuteID = item.getAttribute("id");
        if (attibuteID != hotelTypeHeader) {
            item.remove();
        }
    });
    dynamicFooters.map((item, index) => {
        attibuteID = item.getAttribute("id");
        if (attibuteID != hotelTypeFooter) {
            item.remove();
        }
    });
    activeHeader.setAttribute("style", "display:block");
    activeFooter.setAttribute("style", "display:block");
    if (body != null) {
        body.setAttribute("style", "display:block");
    }
};
const checkValidPage = (hotelid, siteData) => {
    let pagePath;
    pagePath = window.location.pathname;
    siteData.pages.map((item, index) => {
        let page;
        page = pagePath.replace('/', '');
        if (page == item.post_name) {
            console.log(item.acf);
        }
    });
};
const getCookie = (name) => {
    const nameLenPlus = (name.length + 1);
    return document.cookie
        .split(';')
        .map(c => c.trim())
        .filter(cookie => {
        return cookie.substring(0, nameLenPlus) === `${name}=`;
    })
        .map(cookie => {
        return decodeURIComponent(cookie.substring(nameLenPlus));
    })[0] || "";
};
const getHotelTypeHome = (hoteltype) => {
};
const validateHotelID = (hotel, siteData) => __awaiter(void 0, void 0, void 0, function* () {
    let url;
    let hoteltype;
    url = restAPIdomain + '/wp-json/validate-hotel/v1/id/' + hotel.hotelid;
    const request = yield fetch(url);
    hoteltype = yield request.json();
    let ohotel = {
        "hotel": hotel.hotelid,
        "hoteltype": hoteltype,
        "siteData": siteData
    };
    return ohotel;
});
const validateLogin = (siteData) => {
    let pagePath;
    let chotel;
    let page;
    pagePath = window.location.pathname;
    page = pagePath.replace(/\//g, '');
    chotel = getCookie("hotel");
    if (chotel) {
        let hotel = JSON.parse(chotel);
        return validateHotelID(hotel, siteData).then((data) => {
            let pageAccess;
            let pageName;
            let body;
            body = document.body;
            siteData.pages.map((item, index) => {
                pageName = item.post_name;
                if (page == pageName) {
                    if (item.acf.hotel_types) {
                        pageAccess = item.acf.hotel_types.includes(hotel.hoteltype);
                        if (pageAccess) {
                            buildPage(hotel, siteData);
                            return siteData;
                        }
                        if (pageAccess == false || pageAccess == "") {
                            location.href = "/";
                        }
                    }
                }
            });
        });
    }
    else {
        location.href = "../";
    }
};
const searchPages = (search, siteData) => {
    const getSiteData = () => __awaiter(void 0, void 0, void 0, function* () {
        const request = yield fetch(restAPIdomain + '/wp-json/site-data/v1/site');
        let data;
        let siteData;
        data = yield request.json();
        siteData = yield JSON.parse(data);
        return siteData;
    });
    getSiteData().then(function (siteData) {
        let chotel = getCookie("hotel");
        const options = {
            // isCaseSensitive: false,
            // includeScore: false,
            // shouldSort: true,
            // includeMatches: false,
            // findAllMatches: false,
            // minMatchCharLength: 1,
            // location: 0,
            // threshold: 0.6,
            // distance: 100,
            // useExtendedSearch: false,
            // ignoreLocation: false,
            // ignoreFieldNorm: false,
            // fieldNormWeight: 1,
            keys: [
                "post_date",
                "post_title",
                "post_name",
                "post_content"
            ]
        };
        chotel = getCookie("hotel");
        let hotel = JSON.parse(chotel);
        const fuse = new Fuse(siteData.pages, options);
        const pattern = search;
        let searchResults;
        let results;
        let resultsList = [];
        let eleSearchResults;
        searchResults = fuse.search(pattern);
        eleSearchResults = document.getElementById("search-results");
        document.getElementById("search-results").innerHTML = "";
        searchResults.map((item, index) => {
            if (eleSearchResults != null) {
                if (item.item.acf.hotel_types) {
                    if (item.item.acf.hotel_types.includes(hotel.hoteltype)) {
                        //if(item.refIndex == 0) {
                        //console.log(item);
                        //eleSearchResults.insertAdjacentHTML("afterbegin","<li><a href=../" + item.item.post_name +">" + item.item.post_title + "</li>");
                        //resultsList.push("<li><a href=../" + item.item.post_name +">" + item.item.post_title + "</li>");
                        let listItem;
                        listItem = "<li><a href=../" + item.item.post_name + ">" + item.item.post_title + "</li>";
                        resultsList.push(listItem);
                        //}
                    }
                }
            }
        });
        if (resultsList.length > 0) {
            let filResultsList;
            filResultsList = resultsList.join(" ");
            eleSearchResults.insertAdjacentHTML("afterbegin", filResultsList);
        }
        else {
            eleSearchResults.insertAdjacentHTML("afterbegin", "No Results");
        }
        return fuse.search(pattern);
    });
};
document.addEventListener("DOMContentLoaded", (event) => {
    let pagePath;
    let body;
    pagePath = window.location.pathname;
    if (pagePath != "/") {
        const getSiteData = () => __awaiter(void 0, void 0, void 0, function* () {
            const request = yield fetch(restAPIdomain + '/wp-json/site-data/v1/site');
            let data;
            let siteData;
            data = yield request.json();
            siteData = yield JSON.parse(data);
            return siteData;
        });
        getSiteData().then((siteData) => {
            return validateLogin(siteData);
        }).then((siteData) => {
            let searchButton;
            var loginStatus = document.body.classList.contains('logged-in');
            searchButton = Array.from(document.getElementsByClassName("button-nav"));
            // Enable page per admin
            if (loginStatus) {
                body.setAttribute("style", "display:block");
            }
            searchButton.map((item, key) => {
                item.addEventListener("click", () => {
                    let modal;
                    let body;
                    modal = document.getElementById("modal-content");
                    const btnResults = document.getElementById("btn-results");
                    body = document.body;
                    if (modal != null) {
                        modal.setAttribute("class", "modal-open");
                        body.classList.add("modal-open");
                    }
                    if (btnResults != null) {
                        btnResults.addEventListener("click", (event) => {
                            const inputText = document.getElementById("search-text");
                            ;
                            if (inputText != null) {
                                searchPages(inputText.value, siteData);
                            }
                        });
                    }
                });
            });
        });
    }
});
